<script>
import { deletePhoto, updatePhoto } from '@/api/yasldpr/photos'
import user from '@/mixins/user'

export default {
  name: 'YasldprCard',
  mixins: [user],
  props: {
    photoItem: {
      type: Object,
      default: () => {
        return {
          id: '',
          name: '',
          region: '',
          description: '',
          photo: '',
          email: '',
          social_links: {},
          approved: false,
        }
      },
    },
  },
  data() {
    return {
      dialog: false,
      formValues: { approved: false, description: '', name: '' },
    }
  },
  computed: {
    approved() {
      return this.formValues.approved
    },
    approvedText() {
      return this.approved ? 'Одобрено' : 'Отклонено или не проверенно'
    },
    approvedColor() {
      return this.approved ? 'success' : 'error'
    },
    changed() {
      return (
        this.photoItem.approved !== this.formValues.approved ||
        this.formValues.description !== this.photoItem.description ||
        this.formValues.name !== this.photoItem.name
      )
    },
  },
  mounted() {
    this.formValues = { ...this.photoItem }
  },
  methods: {
    async updatePhoto() {
      const resp = await updatePhoto(this.axios, {
        id: this.photoItem.id,
        approved: this.formValues.approved,
        description: this.formValues.description,
        name: this.formValues.name,
        email: this.formValues.email,
        social_links: this.formValues.social_links,
      })
      if (resp.status !== 200) {
        this.showSnackbar(resp.data.message, 'error')
        return
      }
      this.showSnackbar('Обновлено', 'success')
      this.$emit('updated', resp.data)
    },
    async deletePhoto() {
      const resp = await deletePhoto(this.axios, this.photoItem.id)
      if (resp.status !== 204) {
        this.showSnackbar(resp.data.message, 'error')
        return
      }
      this.showSnackbar('Удалено', 'success')
      this.$emit('deleted', this.photoItem)
    },
  },
}
</script>

<template>
  <v-card max-width="600px" class="ma-2">
    <v-card-title>{{ photoItem.name }}</v-card-title>
    <v-card-text>
      <div class="ma-auto">
        <v-img
          :src="photoItem.photo"
          max-width="300"
          max-height="300"
          contain
          class="cursor-pointer ma-auto"
          @click="
            () => {
              dialog = true
            }
          "
        ></v-img>
      </div>
      <v-form>
        <v-text-field
          v-model="formValues.name"
          label="Имя"
          :readonly="!isYasLDPREditor"
          outlined
          hide-details
          class="ma-2"
        >
        </v-text-field>
        <v-text-field
          v-model="formValues.email"
          label="Email"
          readonly
          hide-details
          outlined
          class="ma-2"
        ></v-text-field>
        <v-text-field
          v-model="formValues.description"
          label="Описание"
          outlined
          :readonly="!isYasLDPREditor"
          hide-details
          class="ma-2"
        ></v-text-field>
        <div v-if="photoItem.social_links" class="ma-2">
          <div>социальные сети</div>
          <div v-for="(v, k) in photoItem.social_links" :key="k">
            <a :href="v" :title="v">{{ k }} - {{ v }}</a>
          </div>
        </div>
        <div class="d-flex justify-start align-center">
          <v-chip>{{ photoItem.region }}</v-chip>
          <v-switch
            v-if="isYasLDPREditor"
            v-model="formValues.approved"
            :label="approvedText"
            color="success"
          ></v-switch>
        </div>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn v-if="isYasLDPREditor" :disabled="!changed" color="success" @click="updatePhoto"
        >Сохранить
      </v-btn>
      <v-btn v-if="isYasLDPREditor" color="warning" @click="deletePhoto">Удалить</v-btn>
    </v-card-actions>
    <v-dialog v-model="dialog" scrollable>
      <v-img :src="photoItem.photo" @click="dialog = false" contain></v-img>
    </v-dialog>
  </v-card>
</template>
